export default function TemplateListSkeleton() {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-50 border-b border-gray-200">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Assessment Name</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Version</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody>
          {[...Array(5)].map((_, i) => (
            <tr key={i} className="animate-pulse">
              <td className="px-6 py-4">
                <div className="flex items-center">
                  <div className="w-5 h-5 rounded bg-gray-200 mr-3" />
                  <div>
                    <div className="h-4 w-32 rounded bg-gray-200 mb-2" />
                    <div className="h-3 w-24 rounded bg-gray-100" />
                  </div>
                </div>
              </td>
              <td className="px-6 py-4">
                <div className="h-4 w-10 rounded bg-gray-100" />
              </td>
              <td className="px-6 py-4">
                <div className="h-4 w-16 rounded bg-gray-100" />
              </td>
              <td className="px-6 py-4">
                <div className="h-4 w-20 rounded bg-gray-100" />
              </td>
              <td className="px-6 py-4">
                <div className="flex gap-2">
                  <div className="h-7 w-7 bg-gray-200 rounded" />
                  <div className="h-7 w-7 bg-gray-200 rounded" />
                  <div className="h-7 w-7 bg-gray-200 rounded" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}